import type { Dayjs } from 'dayjs';
import { formatDate } from 'shared/utils/time/format-date';

export type TWhTaskDateValue = [Dayjs, Dayjs] | Dayjs;

interface IFormattedDates {
  arrivalDate: string;
  departureDate: string;
}

export const formatWhTaskDates = (date: TWhTaskDateValue): IFormattedDates => {
  if (Array.isArray(date)) {
    const [start, end] = date;
    return {
      arrivalDate: formatDate(start),
      departureDate: formatDate(end),
    };
  }

  return {
    arrivalDate: formatDate(date),
    departureDate: formatDate(date),
  };
};
